import { z } from 'zod';

export const faqSchema = z.object({
  question: z.string().min(1, 'validation.required'),
  answer: z.string().min(1, 'validation.required'),
  category: z.string().optional(),
  isActive: z.boolean().optional(),
});
